import { useState, useLayoutEffect } from 'react';
import { ViewPortSizes, Breakpoints } from '../types/enums';

/**
 * @description This hook detect the current viewport. eg mobile, tablet, desktop
 *
 * */

export const useDeviceTypeMediaQuery = () => {
  const getWindowSize = (): number =>
    window?.innerWidth || window?.screen?.width || document?.documentElement?.clientWidth || 0;

  const [viewPortType, setViewPortType] = useState<Breakpoints>('' as Breakpoints);

  const determineViewPortType = (windowSize: number): Breakpoints => {
    if (windowSize < ViewPortSizes.SMALL) {
      return Breakpoints.XS;
    }
    if (windowSize < ViewPortSizes.MEDIUM) {
      return Breakpoints.SM;
    }
    if (windowSize < ViewPortSizes.LARGE) {
      return Breakpoints.MD;
    }
    if (windowSize < ViewPortSizes.XLARGE) {
      return Breakpoints.LG;
    }
    return Breakpoints.XL;
  };

  const useBrowserLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : () => 0;

  const watchResize = () => {
    const windowSize = getWindowSize();
    setViewPortType(determineViewPortType(windowSize));
  };

  useBrowserLayoutEffect(() => {
    window.addEventListener('resize', watchResize);
    watchResize();
    return () => window.removeEventListener('resize', watchResize);
  }, []);

  return {
    isMobile: viewPortType === Breakpoints.XS || viewPortType === Breakpoints.SM,
    isTablet: viewPortType === Breakpoints.MD,
    isDesktop: viewPortType === Breakpoints.LG || viewPortType === Breakpoints.XL,
  };
};
